// Shared INR currency utilities

// formatINR(value, { round, prefix, minFraction, maxFraction })
// - Rounds currency as requested (default: ceil)
// - Prefixes with ₹
// - Formats with Indian digit grouping
export function formatINR(value, options = {}) {
  const {
    round = 'ceil',     // 'ceil' | 'floor' | 'round'
    prefix = '₹',
    minFraction = 0,
    maxFraction = 0
  } = options;

  const num = Number(value);
  if (!isFinite(num)) return value ?? '—';

  let rounded = num;
  if (round === 'ceil') {
    rounded = Math.ceil(num);
  } else if (round === 'floor') {
    rounded = Math.floor(num);
  } else {
    rounded = Math.round(num);
  }

  try {
    return `${prefix}${new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: minFraction,
      maximumFractionDigits: maxFraction
    }).format(rounded)}`;
  } catch {
    return `${prefix}${rounded}`;
  }
}